import React, {useEffect, useRef} from 'react';
import {Animated, Easing, View} from 'react-native';
import CCText from '@/Atoms/CCText';

const BASE = '#EFE9D8';

function SkeletonBlock({
  width,
  height,
  radius,
  opacity,
}: {
  width: number | string;
  height: number;
  radius: number;
  opacity: Animated.Value;
}) {
  return (
    <Animated.View
      style={{
        width: width as any,
        height,
        borderRadius: radius,
        backgroundColor: BASE,
        opacity,
      }}
    />
  );
}

export default function InterClubBoardSkeleton({count}: {count: number}) {
  const opacity = useRef(new Animated.Value(0.45)).current;

  useEffect(() => {
    const pulse = Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 0.9,
          duration: 650,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0.45,
          duration: 650,
          easing: Easing.inOut(Easing.ease),
          useNativeDriver: true,
        }),
      ]),
    );
    pulse.start();
    return () => pulse.stop();
  }, [opacity]);

  const rowCount = Math.max(1, Math.min(count, 5));

  return (
    <View testID="inter-club-board-skeleton" style={{paddingHorizontal: 14}}>
      <CCText
        style={{
          fontSize: 13,
          fontWeight: '700',
          color: '#262322',
          marginTop: 12,
          marginBottom: 10,
        }}>
        Top Performing Clubs
      </CCText>
      {Array.from({length: rowCount}).map((_, index) => (
        <View
          key={index}
          testID="inter-club-board-skeleton-row"
          style={{
            minHeight: 54,
            flexDirection: 'row',
            alignItems: 'center',
            gap: 11,
            paddingVertical: 8,
            paddingHorizontal: 11,
            borderRadius: 12,
            backgroundColor: '#fff',
            marginBottom: 6,
          }}>
          <SkeletonBlock width={32} height={32} radius={16} opacity={opacity} />
          <View style={{flex: 1, gap: 7}}>
            <SkeletonBlock width="62%" height={12} radius={5} opacity={opacity} />
            <SkeletonBlock width="38%" height={9} radius={5} opacity={opacity} />
          </View>
          <SkeletonBlock width={42} height={13} radius={5} opacity={opacity} />
        </View>
      ))}
    </View>
  );
}
